import {Injectable} from '@angular/core';
import {AbstractControl, FormBuilder, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';
import {UploadFileFG} from "../../core/model/nachricht-form";
import {UploadFileStatusEnum} from "../../shared/components/controls/ui-controls/upload/upload-file";

export const uploadErrorValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const status = control.get('status')?.value;
    if (status === UploadFileStatusEnum.ERROR) {
        return { uploadError: true };
    }
    return null;
};

@Injectable({providedIn: 'root'})
export class UploadFormFactory {
    constructor(private readonly fb: FormBuilder) {
    }

    /**
     * Erstellt eine FormGroup für eine fehlerhafte Datei.
     */
    createError(fileName: string, errorText: string): UploadFileFG {
        const group = this.fb.group({
            anhangId: [null as string | null, Validators.required],
            fileName: [fileName, Validators.required],
            size: null as number,
            status: [UploadFileStatusEnum.ERROR, Validators.required],
            errorKey: [errorText]
        }, { validators: uploadErrorValidator });
        return group as UploadFileFG;
    }

    /**
     * Erstellt eine FormGroup für eine gerade laufende Upload-Datei.
     */
    createUploading(fileName: string): UploadFileFG {
        const group = this.fb.group({
            anhangId: [null, Validators.required],
            fileName: [fileName, Validators.required],
            size: null as number,
            status: [UploadFileStatusEnum.LOADING, Validators.required],
            errorKey: [null]
        }, { validators: uploadErrorValidator });
        return group as UploadFileFG;
    }

  /**
   * Erstellt eine FormGroup für ein bereits existierenden upload
   */
  createSuccess(fileName: string, anhangId: string): UploadFileFG {
    const group = this.fb.group({
      anhangId: [anhangId, Validators.required],
      fileName: [fileName, Validators.required],
      size: null as number,
      status: [UploadFileStatusEnum.SUCCESS, Validators.required],
        errorKey: [null]
    });
    return group as UploadFileFG;
  }
}